module.exports = __webpack_public_path__ + "static/media/berkshire-newlogo.ca1858eb.svg";